export { EXTERIOR_WORLD } from "./generated/exterior-world.js";
/** Outdoor hunt delivery stays usable until the interior is integrated. */
export const OUTDOOR_DELIVERY = {
    minX: -0.7, maxX: 1.15, minZ: 0.45, maxZ: 1.8, floor: 0.72,
};
export const OUTDOOR_BIRD_HOME = { x: -2.7, z: 6.4, r: 1.4 };
export const exteriorPathZ = (x) => -(39.6 + 1.25 * Math.sin(x / 7.3) + 0.27 * Math.sin(x / 3.1 + 1));
export const exteriorCreekZ = (x) => exteriorPathZ(x) - 3.65 - 0.38 * Math.sin(x / 4.1 + 0.7);
